export const EditIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={13}
    fill="none"
    {...props}
  >
    <path
      fill="#26262A"
      d="M2.125 9.344v2.031h2.031l5.991-5.99-2.031-2.032-5.991 5.99Zm9.593-5.53a.538.538 0 0 0 0-.764L10.45 1.782a.54.54 0 0 0-.763 0l-.992.991 2.032 2.032.99-.992Z"
    />
  </svg>
);
